import {createContext} from "react";
import {useSortable} from "@dnd-kit/sortable";

type RowHandle = {
  attributes: ReturnType<typeof useSortable>["attributes"];
  listeners: ReturnType<typeof useSortable>["listeners"];
};

export const DndEnabledContext = createContext(true);
export const RowHandleContext = createContext<RowHandle | null>(null);
